import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivityInterface } from '@vendasta/crm';
import { CrmActivityAssociationPopoverComponent } from '../../../../activities/association-popover.component';
import { ActivityAssociationService } from '../../../../activities/activity-association.service';
import { AVATAR_WIDTH } from '../../../../../../constants';

@Component({
  selector: 'crm-activity-card',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    GalaxyAvatarModule,
    CrmActivityAssociationPopoverComponent,
  ],
  providers: [ActivityAssociationService],
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  animations: [
    trigger('bodyExpansion', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ActivityCardComponent {
  @Input() activity?: ActivityInterface;
  @Input() showTitle = true;
  @Input() icon = '';
  @Input() showAssociationPopover = true;
  protected readonly AVATAR_WIDTH = AVATAR_WIDTH;

  state = 'collapsed';

  toggle() {
    this.state = this.state === 'expanded' ? 'collapsed' : 'expanded';
  }
}
